import StylesPhoneInputServiceInterface
  from '~/src/components/mui-wrappers/styled/phone-input/styles/StylesPhoneInputServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesPhoneInputServiceStyleOne extends TemplateServiceStyleBase implements StylesPhoneInputServiceInterface {
  public getComponentSx(): Record<string, unknown> {
    return {}
  }
}
